var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopcomputer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 111.9100 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5312-8.54492L92.3828-8.54492C98.4863-8.54492 102.148-12.207 102.148-18.3105L102.148-63.2324C102.148-69.3359 98.4863-72.998 92.3828-72.998L19.5312-72.998C13.4277-72.998 9.76562-69.3359 9.76562-63.2324L9.76562-18.3105C9.76562-12.207 13.4277-8.54492 19.5312-8.54492Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3594-25.9766C17.2852-25.9766 16.7969-26.3672 16.7969-27.4902L16.7969-63.1348C16.7969-64.8926 17.8711-65.9668 19.6289-65.9668L92.2852-65.9668C94.043-65.9668 95.1172-64.8926 95.1172-63.1348L95.1172-27.4902C95.1172-26.3672 94.6777-25.9766 93.5547-25.9766Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6523 0.244141L68.3105 0.244141L68.3105-9.0332L43.6523-9.0332ZM43.6035 5.32227L68.3594 5.32227C70.2637 5.32227 71.875 3.75977 71.875 1.80664C71.875-0.146484 70.2637-1.75781 68.3594-1.75781L43.6035-1.75781C41.6504-1.75781 40.0391-0.146484 40.0391 1.80664C40.0391 3.75977 41.6504 5.32227 43.6035 5.32227Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopcomputer);
export default __webpack_public_path__ + "static/media/desktopcomputer.47ab0edbd432fa94eaa52588d4ac8bf9.svg";
export { ForwardRef as ReactComponent };